import PropTypes from 'prop-types';
import React, { useEffect, useRef, forwardRef } from 'react';
import { Layer, Rect, Transformer } from 'react-konva';
import { updateCropToolProps } from '../actions';

const propTypes = {
  cropping: PropTypes.bool.isRequired,
  cropToolProps: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  ref: PropTypes.any.isRequired,
};

const CropTool = forwardRef(({ cropToolProps, cropping, dispatch, keepAspectRatio }, ref) => {
  const transformerRef = useRef(null);

  // If the crop tool is being used, connect it to the transformer
  useEffect(() => {
    if (cropping) {
      transformerRef.current.setNode(ref.current);
      transformerRef.current.getLayer().batchDraw();
    }
  }, [cropping]);

  const onCropTransformEnd = () => {
    setCropToolProps();
  };

  const onDragEnd = () => {
    setCropToolProps();
  };

  const setCropToolProps = () => {
    const cropTool = ref.current.getAttrs();
    dispatch(
      updateCropToolProps({
        x: cropTool.x,
        y: cropTool.y,
        scaleX: cropTool.scaleX,
        scaleY: cropTool.scaleY,
        width: cropTool.width,
        height: cropTool.height,
      }),
    );
  };

  return (
    cropping && (
      <Layer>
        <Rect ref={ref} draggable {...cropToolProps} onDragEnd={onDragEnd} onTransformEnd={onCropTransformEnd} />
        <Transformer
          ref={transformerRef}
          keepRatio={keepAspectRatio}
          resizeEnabled
          rotateEnabled={false}
          enabledAnchors={['top-left', 'top-right', 'bottom-left', 'bottom-right']}
        />
      </Layer>
    )
  );
});

CropTool.propTypes = propTypes;
export default CropTool;
